import * as React from 'react'
import { GetStaticProps } from 'next'
import { NextSeo } from 'next-seo'
import Image from 'next/image'
import Link from 'next/link'

import Container from '~/components/Container'
import Accordion from '~/components/Accordion'
import NotchedCard from '~/components/NotchedCard'
import ImageDoubleCard from '~/components/ImageDoubleCard'

const title = 'FAQ - Mary AG'
const description = ''

const faqs = [
  {
    question: 'How much is a Mary, and when can I get it?',
    answer:
      'Mary is $1899 CAD or $1699 USD, free shipping. The unit will ship within 3 days or order. Orders for Canadian addresses take 1-3 days in transit. Orders for USA addresses take 7-10 days in transit. '
  },
  {
    question: 'Any pest, mould, smell?',
    answer:
      "Thought you'd ask! Mary has a filtration system built in. No smell, no pest, no mould. You can even dry and cure your herbs in it."
  },
  {
    question: 'How automated is Mary anyway?',
    answer:
      'Mary will take care of almost everything, and maintain optimal light schedules for each phase of the grow. It will also help manage temperature while monitoring humidity, water levels, plant height, and a number of other factors that contribute to plant health. The app will alert you if any plant care is necessary and show you how it is done. For experienced growers, you can also use manual settings to manage how your plant grows.'
  },
  {
    question: 'How big is Mary? How many plants can I fit in there?',
    answer:
      "17.7x12.9x53.1 inches. It may look compact, but it grows a lot more than you'd expect because of our awesome innovations."
  },
  {
    question: 'Where do you ship to?',
    answer:
      'Mainland USA and Canada for now. EU and other countries will shortly follow.'
  },
  {
    question: 'Is Mary high maintenance?',
    answer:
      'Not at all! With its super energy efficient design, you only need to pay about $20 a month for electricity and nutrients.'
  },
  {
    question: 'Do I need to assemble the unit?',
    answer:
      "Naw, it's plug-and-grow, fully assembled. We even re-designed the packaging so you can take out the unit more quickly."
  },
  {
    question: 'How do I control the unit? Is there an app?',
    answer:
      "Mary is connected to your Wi-Fi, and you can access it from anywhere in the world via the companion app. It's got some cool features."
  }
]

export const getStaticProps: GetStaticProps = async () => {
  const data = {
    support: {
      body: 'Interested in becoming a grower?'
    },
    grower: {
      body: 'Are you already a grower? Check out our growing community!'
    }
  }
  return { props: { data } }
}

export default function FaqPage(props) {
  const { support, grower } = props.data
  return (
    <Container className="flex-col">
      <NextSeo title={title} description={description} />
      <div className="bg-black py-20 px-6 md:py-48">
        <h2 className="text-2xl font-medium text-white md:text-center lg:text-4xl">
          Frequently Asked Questions
        </h2>
      </div>
      <div className="bg-white">
        <div className="p-6 xl:p-0 bg-white max-w-7xl mx-auto">
          {faqs.map(({ question, answer }, i) => (
            <div className="border-t border-grey-200 py-4 md:py-8" key={i}>
              <Accordion key={i} title={question} body={answer} />
            </div>
          ))}
        </div>
      </div>
      <section className="pt-52 bg-white overflow-hidden">
        <ImageDoubleCard
          imageSrc="/images/faq.png"
          imageSrcMobile="/images/faq-mobile.png"
          card1={
            <div className="flex flex-col py-16 md:py-20 justify-between h-full">
              <p className="text-white text-lg md:text-xl pb-8">
                {support.body}
              </p>
              <Link href="/support">
                <span className="text-black text-sm md:text-base bg-pink-800 self-start rounded-full py-3 px-8 cursor-pointer">
                  Learn More
                </span>
              </Link>
            </div>
          }
          card1Style="bg-opacity-90 w-full md:w-165 px-6 md:px-28 flex-shrink-0 flex-grow-0 -mb-18 pb-18 bg-grey-700"
          card2={
            <div className="flex flex-col py-16 md:py-20 justify-between h-full">
              <p className="text-white text-lg md:text-xl pb-8">
                {grower.body}
              </p>
              <Link href="/growers">
                <span className="text-black text-sm md:text-base bg-white self-start rounded-full py-3 px-8 cursor-pointer">
                  Join The Community
                </span>
              </Link>
            </div>
          }
          card2Style="bg-green-500 w-full md:w-165 px-6 md:px-28 flex-shrink-0 flex-grow-0"
          imageNegativeTopMargin="-mt-28"
        />
      </section>
    </Container>
  )
}
